import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import {
    DropdownType,
    effectDropdownData,
} from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_DROPDOWN, TOOLBAR_EFFECT, TOOLBAR_TEXT_EFFECT_ICON } from '@editor/src/img/pageIndex';
import { wrapIdForCommon, wrapIdForPic, wrapIdForText, wrapIdForTextTab } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.EFFECT,
    tipMsg: i18n.t('效果设置'),
    title: i18n.t('效果'),
    icon: TOOLBAR_EFFECT,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.EFFECT,
        data: effectDropdownData,
    },
    twdConfig: {
        action: TDWActionType.STYLE,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
    },
    {
        name: wrapIdForPic(config.id),
        icon: <img src={config.icon} alt={''}/>,
        tooltip: i18n.t('图片效果'),
        hasArrow: true,
        text: i18n.t('图片效果'),
    },
    {
        name: wrapIdForCommon(config.id),
        icon: <img src={config.icon} alt={''}/>,
        tooltip: i18n.t('效果'),
        hasArrow: true,
        text: i18n.t('效果'),
    },
    {
        name: wrapIdForText(config.id),
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        hasArrow: true,
        text: config.title,
        style: {
            width: 'auto',
            maxWidth: 60,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
    {
        name: wrapIdForTextTab(config.id),
        icon: <img src={TOOLBAR_TEXT_EFFECT_ICON} alt={''}/>,
        tooltip: config.tipMsg,
        text: config.title,
        hasArrow: true,
    },
];
